import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { addAllList } from 'modules/common';

import MbTabs from 'components/organisms/MbTabs';

import Apply from 'pages/Main/Product/Adex/Apply';
import Matching from 'pages/Main/Product/Adex/Matching';
import TransMatching from 'pages/Main/Product/Adex/TransMatching';
import MainTemplate from 'pages/templates/MainTemplate';

const Adex = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));
  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  let itemTypeList = [
    { label: '전체', value: null },
    { label: '게재중', value: '01' },
    { label: '중지', value: '02' },
  ];

  let itemStateList = [
    { label: '전체', value: '00' },
    { label: '신규', value: '01' },
    { label: '대기', value: '02' },
    { label: '반려', value: '03' },
  ];

  return (
    <MainTemplate>
      <MbTabs
        name="Adex"
        tabMenuList={tabList()}
        tabs={{
          '/product/adex/transMatching': {
            tabComponent: (
              <>
                <TransMatching
                  sendTpCode="01"
                  itemTypeList={itemTypeList}
                  addAllList={addAllList}
                />
              </>
            ),
          },
          '/product/adex/matching': {
            tabComponent: (
              <>
                <Matching
                  sendTpCode="02"
                  itemTypeList={itemTypeList}
                  addAllList={addAllList}
                />
              </>
            ),
          },
          '/product/adex/apply': {
            tabComponent: (
              <>
                <Apply
                  sendTpCode="03"
                  addAllList={addAllList}
                  itemStateList={itemStateList}
                />
              </>
            ),
          },
        }}
      ></MbTabs>
    </MainTemplate>
  );
};

export default Adex;
